module.exports = __webpack_public_path__ + "static/pdt_marca-0772f8e6fb2d5965cf0328e5e5af943c.png";